import React from "react";
import FormComponent from "./Components/FormComponent";

export default class PostLiveChatSurveyFrom extends FormComponent {
    /**
     * Determines if the field is required and if it is optional, returns a hidden input with an empty
     * value defined. This is required by Kore as they state they cannot handle a missing input they sent
     * and need an empty string at minimum. This should be placed BEFORE the mapped radio group as any
     * selection made after will overwrite this in the form submit handling.
     * @param {Object} field - The form input field being evaluated.
     * @returns Returns a hidden input to mask optional fields if needed.
     */
    createOptionalHidden(field) {
        if (field.required === 'true') {
            return;
        }

        return <input type='hidden' name={field.value} value='' />
    }

    /**
     * Renders the collection of radio input objects per input group passed through from
     * the bot.
     * @param {Object} field The object that defines the radio grouping
     * @param {Number} index The current index of the radio group being rendered.
     * @returns The rendered collection of the radio input input grouping.
     */
    createRadioGroup(field, index) {
        return  <div className='form__input-wrapper' role='radiogroup' aria-labelledby={`radioGroup-${this.formId}-${index}`} key={field}>
                    <div className='label' id={`radioGroup-${this.formId}-${index}`}>
                        {field.label}
                    </div>
                    {this.createOptionalHidden(field)}
                    {field.options.map((radio, index) => {
                        return this.createRadioInput(field, radio, index)
                    })}
                </div>
    }

    /**
     * Renders out the singular radio input from the form data. The main determination is against
     * if the field is optional or not. We then add the required attribute in the input based
     * on that determination.
     * @param {Object} field The object that defines the radio grouping
     * @param {Object} radio The radio input object that is being rendered in the radio group.
     * @param {Number} index The current index of the radio group being rendered.
     * @returns
     */
    createRadioInput(field, radio, index) {
        if (field.required === 'true') {
            return  <div className='radio__wrapper' key={radio}>
                        <input type='radio' name={field.value} value={radio.value} id={`radio-${this.formId}-${index}`} className='radio__input' required/>
                        <label htmlFor={`radio-${this.formId}-${index}`}>{radio.label}</label>
                    </div>
        }

        return  <div className='radio__wrapper' key={radio}>
                    <input type='radio' name={field.value} value={radio.value} id={`radio-${this.formId}-${index}`} className='radio__input'/>
                    <label htmlFor={`radio-${this.formId}-${index}`}>{radio.label}</label>
                </div>
    }

    render() {
        if (this.props.message.isChatHistory || this.state.formSubmitted) {
            return (
                <div className={this.generateSenderClassName('post-live-chat')}>
                    {this.generateSenderMessage()}
                    <div className='message-text'>
                        <div className='post-live-chat__heading'>
                            {this.props.payload.heading}
                        </div>
                        <div className='post-live-chat__description'>
                            {this.props.payload.description}
                        </div>
                    </div>
                </div>
            )
        }
        return (
            <div className={this.generateSenderClassName('post-live-chat')}>
                {this.generateSenderMessage()}
                <div className='message-text'>
                    <div className='post-live-chat__heading'>
                        {this.props.payload.heading}
                    </div>
                    <div className='post-live-chat__description'>
                        {this.props.payload.description}
                    </div>
                    <form className='post-live-chat__form form' onSubmit={this.submitForm} data-submit-and-close='true'>
                        {this.props.payload.formFields.map((field, index) => {
                            return this.createRadioGroup(field, index)
                        })}
                        <button className='button--black' type='submit' title='Submit your feedback.'>
                            {this.props.payload.submitBtnText}
                        </button>
                    </form>
                </div>
            </div>
        );
    }
}